import { defineAction } from '~/prix'
import { z } from 'zod'
import creditProgramCreateAction from './creditProgramCreate.action.json' with { type: 'json' }
import { creditProgramCreateInputObject, creditProgramObject } from '../creditProgramObject'

const creditProgramCreateDefinition = defineAction({
  ...creditProgramCreateAction,

  input: creditProgramCreateInputObject,
  output: z.object({ id: creditProgramObject.shape.id }),
})

export default creditProgramCreateDefinition

